// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

html {
    font-size: 100%;
}

body {
    margin: 0;
    padding: 0;
    font-family: var(--mantine-font-family);
    line-height: var(--mantine-line-height);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: var(--mantine-color-gray-0);
}

#root {
    min-height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/styles/global.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,uCAAuC;IACvC,uCAAuC;IACvC,mCAAmC;IACnC,kCAAkC;IAClC,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\nhtml {\n    font-size: 100%;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: var(--mantine-font-family);\n    line-height: var(--mantine-line-height);\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background-color: var(--mantine-color-gray-0);\n}\n\n#root {\n    min-height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
